<template>
  <div>
    <el-upload
      class="quill-uploader"
      style="height:0"
      :action="upload.url"
      :data="upload.data"
      :show-file-list="false"
      :before-upload="
        file => {
          return osg.beforeUpload(file, null, null, null, this);
        }
      "
      :on-success="
        (response, file, fileList) => {
          return osg.uploadSuccess(response, file, fileList, null, null, null, 'quill');
        }
      "
      :on-error="osg.uploadError"
    ></el-upload>
    <!-- 如：v-model="content" -->
    <quill-editor
      v-if="value.indexOf('.') == -1"
      class="editor"
      v-model="formData[value]"
      ref="myQuillEditor"
      :options="$util.vqeditor.editorOption"
    ></quill-editor>
    <!-- 如：v-model="exts.content" -->
    <quill-editor
      v-else
      class="editor"
      v-model="formData[value.split('.')[0]][value.split('.')[1]]"
      ref="myQuillEditor"
      :options="$util.vqeditor.editorOption"
    ></quill-editor>
  </div>
</template>
<script>
export default {
  props: {
    formData: Object,
    value: String
  },
  data() {
    return {
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  methods: {}
};
</script>
